import React from "react";
import { Paper, Typography } from "@mui/material";

/**
 * 中英交替版 PDF の使い方の説明。
 * 無料版（free）と Pro 版（pro）の両方で同じ文面を出すので、ここを唯一の定義とする。
 */
const PdfUsageNote = () => {
  return (
    <Paper
      variant="outlined"
      sx={{ mt: 4, mb: 3, p: 3, width: "100%", maxWidth: 600 }}
    >
      <Typography component="p">
        我们推荐您使用中英文交替版PDF文件。如果您使用Chrome浏览器自带的PDF阅读器，请点击右上角的三点按钮，选择双页视图以同时显示中文翻译和英语原文。
      </Typography>
      <Typography component="p">
        用于打印机的交替版文件在开头插入了一页空白页。确保您使用打印机的双面左右打印功能时，文件翻开后中文翻译在左侧，对应英文原文在右侧。
      </Typography>
    </Paper>
  );
};

export default PdfUsageNote;
